import { downloadFile, getResFilename, withLoading } from 'prace-common-components'
import { clientApi } from '..'
import { CINESGetAppsApiPayload } from './types'

export const cinesApi = clientApi.injectEndpoints({
  endpoints: (build) => ({
    //TODO: Handle any
    getCINESApps: build.query<any, CINESGetAppsApiPayload>({
      ...withLoading,
      query: ({ limit, offset, search = '' }) => ({
        url: `/cines?limit=${limit}&offset=${offset}&search=${search}`,
      }),
    }),
    //TODO: Handle any
    getCINESApp: build.query<any, StringNumber>({
      ...withLoading,
      query: (id) => ({
        url: `/cines/${id}`,
      }),
    }),
    downloadCinesFile: build.query<void, string>({
      query: (fileNameExtension) => ({
        url: `/cines/file/${fileNameExtension}`,
        responseHandler: async (res) =>
          res.status < 300 ? downloadFile(getResFilename(res), await res.blob()) : undefined,
        cache: 'no-cache',
      }),
    }),
    downloadProposalFiles: build.query<void, string>({
      query: (id) => ({
        url: `/cines/proposal/${id}`,
        responseHandler: async (res) =>
          res.status < 300 ? downloadFile(getResFilename(res), await res.blob()) : undefined,
        cache: 'no-cache',
      }),
    }),
    downloadExport: build.query<void, string>({
      query: (type) => ({
        url: `/cines/export/${type}`,
        responseHandler: async (res) =>
          res.status < 300 ? downloadFile(getResFilename(res), await res.blob()) : undefined,
        cache: 'no-cache',
      }),
    }),
  }),
})

export const {
  useGetCINESAppQuery,
  useGetCINESAppsQuery,
  useLazyDownloadCinesFileQuery,
  useLazyDownloadProposalFilesQuery,
  useLazyDownloadExportQuery,
} = cinesApi
